const hasCookieCheck = (setYoutubeCookieConfirmation) => {
    if(window.BorlabsCookie) {
        if(window.borlabsCookieConfig.pluginVersion || window.borlabsCookieConfig.settings.pluginVersion) {
            if (window.BorlabsCookie.Consents.hasConsent("youtube")) {
                setYoutubeCookieConfirmation(true)
            } else {
                setYoutubeCookieConfirmation(false)
            }
        } else {
            if (window.BorlabsCookie.checkCookieConsent("youtube")) {
                setYoutubeCookieConfirmation(true)
            } else {
                setYoutubeCookieConfirmation(false)
            }
        }
    }
}

export default hasCookieCheck